import base from './base'

export default {
  ...base,
  colors: {
    ...base.colors,
    shadow1: '#2F80ED',
    text1: '#17113a',
    text2: '#17113a',
    text3: '#CED0D9',
    text4: '#CED0D9',

    // backgrounds / greys
    bg0: '#F5F3F3',
    bg1: '#00c2cb',
    bg2: '#F5F3F3',
    bg3: '#EDEEF2',
    bg4: '#CED0D9',
    bg5: '#43d3db',
    modalBG: 'rgba(0,0,0,0.3)',
    advancedBG: 'rgba(255,255,255,0.6)',

    //primary colors
    primary1: '#43d3db',
    primary4: '#bfe0e2',
    primary5: '#daedef',

    // color text
    primaryText1: '#13aab5',
    buttonText: '#ffffff',

    // secondary colors
    secondary1: '#13aab5'
  }
}
